import { useGridConfig } from "../../../../../search/hooks";
import useGetSelectedLayout from "../../../../hooks/useGetSelectedLayout";
import { LayoutsResponse } from "../../../layout-editor/@types";
import { useGetLayouts } from "../../../layout-editor/hooks";
import LayoutActionDropdown from "./LayoutActionDropdown";

const LayoutActions = () => {
  const { postConfig } = useGridConfig();
  const { data: layouts } = useGetLayouts();
  const selectedLayout = useGetSelectedLayout();

  const handleClick = (id: number, type: keyof LayoutsResponse) => {
    postConfig({ samples_layout: { id, type } });
  };

  return (
    <LayoutActionDropdown
      user={layouts?.user ?? []}
      shared={layouts?.shared ?? []}
      rl={layouts?.rl ?? []}
      path={`/samples/layouts/${selectedLayout?.type}/${selectedLayout?.id}/`}
      selected={selectedLayout}
      onClick={handleClick}
    />
  );
};

export default LayoutActions;
